module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.7781/img/app-marketplace-network-2x.png"